import { ApiBase } from "../../base/_ApiBase";
import { ProductTypeModel } from "../../models/product-type/ProductTypeModel";

export const ProductTypeApi = new class ProductTypeApi extends ApiBase<ProductTypeModel>{
    constructor({ baseUrl }: { baseUrl: string; }) {
        super(baseUrl);
    }
}({ baseUrl: '/product-type' });